import { RoutePath } from 'enums/routePath';

const ROOT = `/contacts`;
const CONTACT = `${ROOT}/:id`;
const CONTACT_INTERACTIONS = `${ROOT}/:id/interactions`;
const CONTACT_INTERACTION = `${CONTACT_INTERACTIONS}/:interactionId`;
const CONTACT_SUGGESTED = `${ROOT}/suggested`;

const CONTACT_FILES = `${ROOT}/:id/files`;
const CONTACT_PROFILE = `${ROOT}/:id/profile`;

export const contactPaths = {
  [RoutePath.CONTACT]: CONTACT,
  [RoutePath.CONTACT_INTERACTIONS]: CONTACT_INTERACTIONS,
  [RoutePath.CONTACT_INTERACTION]: CONTACT_INTERACTION,
  [RoutePath.CONTACT_SUGGESTED]: CONTACT_SUGGESTED,
  [RoutePath.CONTACT_FILES]: CONTACT_FILES,
  [RoutePath.CONTACT_PROFILE]: CONTACT_PROFILE,
};

export const contactPathArray = Object.values(contactPaths);

export const contactsPaths = {
  [RoutePath.CONTACTS]: ROOT,
};

const paths = {
  ...contactsPaths,
  ...contactPaths,
};

export const pathArray = Object.values(paths);

export default paths;
